import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Select,
  SelectItem,
} from "@heroui/react";
import { useDispatch, useSelector } from "react-redux";
import { editHeadingAsync } from "../../../redux/heading";
import { getFullTranscriptionByIdAsync } from "../../../redux/transcription";
import AppButton from "../../common/AppButton";

const getLevelBadgeClasses = (level) => {
  switch (level) {
    case 1:
      return "bg-emerald-100 text-emerald-800 border-emerald-200";
    case 2:
      return "bg-sky-100 text-sky-800 border-sky-200";
    case 3:
      return "bg-amber-100 text-amber-800 border-amber-200";
    case 4:
      return "bg-rose-100 text-rose-800 border-rose-200";
    default:
      return "bg-gray-100 text-gray-700 border-gray-200";
  }
};

const EditHeadingModal =({ heading, isOpen, onClose, sessionId }) => {
  const dispatch = useDispatch();
  const fullTranscription = useSelector((state) => state.transcriptions.fullTranscription);


  const [content, setContent] = useState(heading.content || "");
  const [typeValue, setTypeValue] = useState(heading.type || "Heading 2");

  useEffect(() => {
    if (heading) {
      setContent(heading.content || "");
      setTypeValue(heading.type || "Heading 2");
    }
  }, [heading]);

  

  const handleSave = async () => {
    await dispatch(
      editHeadingAsync({
        id: heading.id,
        payload: {
          content: content,
          type: typeValue,
        },
      })
    );

    await dispatch(getFullTranscriptionByIdAsync(fullTranscription.id))

    onClose();
  };

  return (
    <Modal isOpen={isOpen} onOpenChange={onClose} size="lg" placement="center">
      <ModalContent>
        {(modalClose) => (
          <>
            <ModalHeader>Überschrift bearbeiten</ModalHeader>
            <ModalBody className="space-y-4">
              <Input
                label="Inhalt"
                placeholder="z.B. 1.1 Abschnitt"
                value={content}
                onChange={(e) => setContent(e.target.value)}
              />
              <Select
                label="Überschriftentyp"
                selectedKeys={new Set([typeValue])}
                onSelectionChange={(keys) => {
                  const val = Array.from(keys)[0];
                  if (val) setTypeValue(val);
                }}
                renderValue={(items) => {
                  return items.map((item) => {
                    const level = parseInt(item.key.replace("Heading ", ""), 10);
                    return (
                      <span key={item.key} className="flex items-center gap-2">
                        <span
                          className={`shrink-0 inline-flex items-center justify-center rounded-full border px-2 py-0.5 text-[10px] font-semibold ${getLevelBadgeClasses(level)}`}
                        >
                          L{level}
                        </span>
                        {item.key}
                      </span>
                    );
                  });
                }}
              >
                {["Heading 1","Heading 2","Heading 3","Heading 4"].map((t) => {
                  const level = parseInt(t.replace("Heading ", ""), 10);
                  return (
                    <SelectItem key={t} value={t} textValue={t}>
                      <span className="flex items-center gap-2">
                        <span
                          className={`shrink-0 inline-flex items-center justify-center rounded-full border px-2 py-0.5 text-[10px] font-semibold ${getLevelBadgeClasses(level)}`}
                        >
                          L{level}
                        </span>
                        {t}
                      </span>
                    </SelectItem>
                  );
                })}
              </Select>
            </ModalBody>
            <ModalFooter>
              <Button variant="bordered" color="danger" radius="full" onPress={onClose}>
                Abbrechen
              </Button>

              <AppButton width="w-[150px]" onClick={handleSave}>
                Speichern
              </AppButton>

            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
export default EditHeadingModal;
